import React from "react";

const FacebookIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="27"
      height="27"
      viewBox="0 0 27 27"
      fill="none"
    >
      <g clipPath="url(#clip0_2_582)">
        <path
          d="M21.0165 26.4H5.38346C2.41489 26.4 0 23.9851 0 21.0165V5.38346C0 2.41489 2.41489 0 5.38346 0H21.0165C23.9851 0 26.4 2.41489 26.4 5.38346V21.0165C26.4 23.9851 23.9851 26.4 21.0165 26.4ZM5.38346 1.47389C3.22592 1.47389 1.47389 3.22851 1.47389 5.38346V21.0165C1.47389 23.1741 3.22851 24.9261 5.38346 24.9261H21.0165C23.1741 24.9261 24.9261 23.1715 24.9261 21.0165V5.38346C24.9261 3.22592 23.1715 1.47389 21.0165 1.47389H5.38346Z"
          fill="#364F8E"
        />
        <path
          d="M15.9762 7.81395H17.3643V4.7934H15.2744C12.3136 4.7934 10.9073 6.55322 10.9073 9.06429V11.4428H8.58858V14.3126H10.9073V21.6118H14.3853V14.3126H16.7041L17.3617 11.4428H14.3827V9.4828C14.3827 8.67957 14.8221 7.81395 15.9736 7.81395H15.9762Z"
          fill="#364F8E"
        />
      </g>
      <defs>
        <clipPath id="clip0_2_582">
          <rect width="26.4" height="26.4" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default FacebookIcon;
